export default "__VITE_PUBLIC_ASSET__1d428c1a__"